import { ArrowDownward, ArrowUpward, Sort } from '@mui/icons-material';
// import { computed, makeObservable } from 'mobx';

import React from 'react';

import FlexRow from '../../Flex/FlexRow';
import Input from '../../Input/Input';
import Tooltip from '../../Tooltip/Tooltip';
import injectStores from '../../RootStore/injectStores';

interface DataGridHeaderCellProps {
  style: React.CSSProperties;
  rowIndex: number;
  columnIndex: number;
  dataGridStore?: Record<string, unknown>;
  namespaceId: string;
}

interface SortIndicatorProps {
  sortDirection: string;
}

class SortIndicator extends React.PureComponent<SortIndicatorProps> {
  render() {
    const { sortDirection } = this.props;
    if (sortDirection === 'DESC') {
      return <ArrowDownward />;
    }
    return <ArrowUpward />;
  }
}

class DataGridHeaderCell extends React.PureComponent<DataGridHeaderCellProps> {
  // constructor(props: DataGridHeaderCellProps) {
  //   super(props);
  //   makeObservable(this, {
  //     sortType: computed,
  //     columnKey: computed,
  //     columnTitle: computed,
  //   });
  // }

  handleSort = () => {
    const { namespaceId, dataGridStore } = this.props;
    const currentStore = dataGridStore.namespaces[namespaceId];
    const { sortState, handleMultiSort, removeSortBy } = currentStore;
    if (sortState.sortBy.includes(this.columnKey)) {
      const currentSortState = sortState.sortDirection[this.columnKey];
      if (currentSortState === 'DESC') {
        return removeSortBy(this.columnKey);
      }
      return handleMultiSort({
        sortBy: this.columnKey,
        sortDirection: currentSortState === 'ASC' ? 'DESC' : 'ASC',
      });
    }
    return handleMultiSort({ sortBy: this.columnKey, sortDirection: 'ASC' });
  };

  get sortType() {
    return 'string';
  }

  get columnKey() {
    const { columnIndex, namespaceId } = this.props;
    if (
      !this.props.dataGridStore.namespaces[namespaceId].currentColumnHeaders[
        columnIndex
      ]
    )
      return '';
    return (
      this.props.dataGridStore.namespaces[namespaceId].currentColumnHeaders[
        columnIndex
      ].key || ''
    );
  }

  get columnTitle() {
    const { columnIndex, namespaceId } = this.props;
    if (
      !this.props.dataGridStore.namespaces[namespaceId].currentColumnHeaders[
        columnIndex
      ]
    )
      return '';
    return this.props.dataGridStore.namespaces[namespaceId]
      .currentColumnHeaders[columnIndex].title;
  }

  render() {
    const { style, rowIndex, columnIndex, dataGridStore, namespaceId } =
      this.props;

    const currentStore = dataGridStore.namespaces[namespaceId];
    const {
      sortState,
      filterState,
      setFilter,
      setCurrentCellHover,
      removeColumnEnabled,
    } = currentStore;

    if (rowIndex === 0) {
      return (
        <div
          style={{
            ...style,
            border: '1px solid grey',
            backgroundColor: '#ffffff',
            textAlign: 'center',
            width: typeof style.width === 'number' ? style.width - 2 : style.width,
            height: typeof style.height === 'number' ? style.height - 2 : style.height,
          }}
          onMouseOver={(e) => setCurrentCellHover(columnIndex, undefined)}
        >
          <h4 style={{ marginTop: 12, marginBottom: 12 }}>
            {this.columnTitle}
          </h4>
        </div>
      );
    }
    if (removeColumnEnabled && columnIndex === 0) {
      // Dont show filter on remove column
      return (
        <div
          style={{
            ...style,
            border: '1px solid grey',
            backgroundColor: '#ffffff',
            textAlign: 'center',
            width: typeof style.width === 'number' ? style.width - 2 : style.width,
            height: typeof style.height === 'number' ? style.height - 2 : style.height,
          }}
          onMouseOver={(e) => setCurrentCellHover(columnIndex, undefined)}
        />
      );
    }

    const sortStateIndex = sortState?.sortBy?.indexOf(this.columnKey);
    const showSortIndicator = sortStateIndex > -1;
    const sortDirection = sortState.sortDirection[this.columnKey];
    let sortTooltip = `Sort Ascending`;
    if (sortDirection === 'ASC') {
      sortTooltip = `Sort Descending`;
    }
    if (sortDirection === 'DESC') {
      sortTooltip = `Remove Sort`;
    }

    return (
      <div
        style={{
          ...style,
          border: '1px solid grey',
          backgroundColor: '#ffffff',
          textAlign: 'center',
          cursor: 'pointer',
          width: typeof style.width === 'number' ? style.width - 2 : style.width,
          height: typeof style.height === 'number' ? style.height - 2 : style.height,
        }}
        onMouseOver={(e) => setCurrentCellHover(columnIndex, undefined)}
      >
        <FlexRow style={{ justifyContent: 'space-between' }}>
          <Input
            formControlSX={{ margin: '0px' }}
            fullWidth
            type="search"
            labelText={`Sort${
              showSortIndicator ? ` (${sortStateIndex + 1})` : ''
            }/Filter`}
            value={filterState[this.columnKey] || ''}
            onChange={(value: string) => setFilter(this.columnKey, value)}
            startAdornment={
              <Tooltip title={sortTooltip}>
                {showSortIndicator ? (
                  <div
                    style={{
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      this.handleSort();
                    }}
                  >
                    <SortIndicator sortDirection={sortDirection} />
                  </div>
                ) : (
                  <div
                    style={{
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      this.handleSort();
                    }}
                  >
                    <Sort />
                  </div>
                )}
              </Tooltip>
            }
          />
        </FlexRow>
      </div>
    );
  }
}

export default injectStores(DataGridHeaderCell);
